export const BRAND_PRIMARY_MEDIUM = '#099B09'
export const SYSTEM_GRAYSCALE_25 = '#D7D9DC'
export const SYSTEM_DETRIMENTAL_MEDIUM = '#C62928'
